<div class="emptystate apierrorstate">
    <img src="/assets/images/myGoal/api-error-state.svg" />
    <b>There seems to be a problem!</b>
    <p>Looks like there’s an issue on our <br /> side. Please try reloading once </p>
    <button class="btn btn-primary" (click)="reloadState()">Reload</button>
</div>